import React from "react"
import { useTranslation } from "react-i18next"

import { thousandSeparator } from "utils"
import classes from "./CheckoutPaymentListHeader.module.scss"

const CheckoutPaymentListHeader = (props) => {
  const { total } = props

  const [t] = useTranslation()

  return (
    <div className={classes["payable-container"]}>
      <span className={classes["title"]}>
        {t("پرداختی")}
      </span>
      <span className={classes["payable"]}>
        {t("قابل_پرداخت")}{" "}
        <span className={classes["total"]}>
          {thousandSeparator(total)}
        </span>
      </span>
    </div>
  )
}

export default CheckoutPaymentListHeader